import { useEffect, useRef } from 'react';

export const useClickOutside = (onClickOutside: () => void) => {
	const clickOutsideRef = useRef<any>(null);

	useEffect(() => {
		function handleClickOutside(event: MouseEvent) {
			if (clickOutsideRef.current && !clickOutsideRef.current.contains(event.target as Node)) {
				onClickOutside();
			}
		}

		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [onClickOutside]);

	return { clickOutsideRef };
};

export default useClickOutside;
